import { createSchema, transformToDocumentSchema, transformToLeanSchema, LeanTypes, } from '@wix/lean-components-infra';
import { string, object as yupObject, mixed, } from 'yup';
import { defaultProperties } from './Core.schema';
export const createDataRef = (schemas) => string().meta({ schemas });
export const createWeakDataRef = (schemaType) => string().meta({ schemaType, weakRef: true });
export const createBaseSchema = (type, schema) => {
    const baseSchema = yupObject({
        id: string().required(),
        type: mixed()
            .oneOf([type])
            .default(type)
            .meta({ leanSchema: { type: LeanTypes.small_string } }),
    });
    return schema.concat(baseSchema);
};
export const createBasePropertiesSchema = (type, schema) => createBaseSchema(type, schema).concat(defaultProperties);
export const createDataSchema = (name, defineSchema, options = {}) => {
    const schema = createSchema(defineSchema, options);
    return createBaseSchema(name, schema);
};
export const createPropertiesSchema = (name, defineSchema, options = {}) => {
    const schema = createSchema(defineSchema, options);
    return createBasePropertiesSchema(name, schema);
};
const isSchemaBuilderFunction = (object) => 'describe' in object && 'meta' in object;
const toJSONSchema = (object) => {
    const isDraft = !!object.describe().meta
        .isDraftSchema;
    const fields = object.fields;
    // We want to strip the id from our output schema ( DM should handle id)
    delete fields.id;
    const leanSchema = transformToLeanSchema.fromYup(fields);
    return transformToDocumentSchema(leanSchema, {
        isDraft,
    });
};
const resolveAdditionalSchemas = (object) => {
    return Object.entries(object).reduce((acc, [key, schema]) => {
        const resolvedSchema = isSchemaBuilderFunction(schema)
            ? toJSONSchema(schema)
            : schema;
        acc[key] = resolvedSchema;
        return acc;
    }, {});
};
export function createComponentSchema(name, schema, additionalSchemas) {
    const resolvedSchema = isSchemaBuilderFunction(schema)
        ? toJSONSchema(schema)
        : schema;
    const resolvedAdditionalSchemas = additionalSchemas
        ? resolveAdditionalSchemas(additionalSchemas)
        : {};
    return Object.assign({ [name]: resolvedSchema }, resolvedAdditionalSchemas);
}
//# sourceMappingURL=createComponentSchema.js.map